const SEPARATOR = ': ';
/**
 * Parse a `description_full` string into ordered entries. Returns `[]` for
 * null / blank input so callers can render nothing without special-casing.
 * Splits each line only on the first `": "`, so values may contain colons.
 */
export function parseDescriptionFull(text) {
    if (!text)
        return [];
    const entries = [];
    for (const rawLine of text.split('\n')) {
        const line = rawLine.trim();
        if (line === '')
            continue;
        const sep = line.indexOf(SEPARATOR);
        if (sep === -1) {
            entries.push({ kind: 'text', value: line });
            continue;
        }
        const label = line.slice(0, sep).trim();
        const value = line.slice(sep + SEPARATOR.length).trim();
        if (label === '' || value === '') {
            entries.push({ kind: 'text', value: line });
            continue;
        }
        entries.push({ kind: 'pair', label, value });
    }
    return entries;
}
//# sourceMappingURL=parseDescriptionFull.js.map